/* eslint-disable arrow-body-style */
import http from '@/utils/http';
import {
  UserInfoType,
  NavMenuItemType,
  SummaryType,
  RecentlyViewedType,
  HomeUrlType,
  NoteworthyType,
  UpcomingGameType,
  NewReleaseGameType,
  BigRiserGameType,
  AnnouncementType,
  ICOSConfig,
  IFeedback,
  ShowNewBeta,
  INavStudioItem
} from '@/pages/home/types/home';

// 用户信息
export const getUserInfo: () => Promise<UserInfoType> = () => {
  return http({
    url: '/api/v1/permission/userInfo',
    method: 'get',
    setAuth: true
  }) as Promise<UserInfoType>;
};

export const getUserDetail = () => {
  return http({
    url: '/api/v1/permission/userDetail',
    method: 'get',
    setAuth: true,
  });
};

// 获取头部导航
export const getNavMenuList: () => Promise<NavMenuItemType[]> = () => {
  return http({
    url: '/api/v1/permission/getListMenu',
    method: 'get',
    formatData: (data: any) => {
      const { listMenu = [] } = data || {};
      return listMenu;
    }
  }) as Promise<NavMenuItemType[]>;
};

// 获取头部Studio导航
export const getNavStudioList: () => Promise<INavStudioItem[]> = () => {
  return http({
    url: '/api/v2/dashboard/studio/list',
    method: 'get',
    formatData: (data: any) => {
      const resultData = data?.map((item: any) => {
        return {
          ...item,
          studio_dashboard_list: item?.studio_dashboard_list || [],
          // 工作室是否有首页权限
          haveHome: item?.studio_dashboard_list?.some((dashboardItem: any)=>{
            return dashboardItem?.path === '/home';
          }) || false
        };
      });
      return resultData || [];
    }
  }) as Promise<INavStudioItem[]>;
};

// 操作日志API
export const operationLog: (data: any, opt?: any) => Promise<any> = (data, opt = {}) => {
  opt = Object.assign(opt, {
    url: `/api/v1/permission/operationLog`,
    method: 'post',
    data,
    errorHandler: true,
  });
  return http(opt);
};

// 获取Home DataMap
export const getDataSummary: () => Promise<SummaryType> = () => {
  return http({
    url: '/api/v1/intelligence_pc/datamap/data/summary',
    method: 'post',
  }) as Promise<SummaryType>;
};

export const getAnnouncements: () => Promise<AnnouncementType> = () => {
  return http({
    url: '/api/v1/homepage/pc/message',
    method: 'post',
  }) as Promise<AnnouncementType>;
};

// 获取Recently Viewed
export const getDataRecentlyViewed: (payload: any) => Promise<RecentlyViewedType[]> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/recent_view',
    method: 'post',
    data: payload,
    formatData: (data: any) => {
      const { list = [] } = data || {};
      return list;
    }
  }) as Promise<RecentlyViewedType[]>;
};

/** Home 获取点击标题跳转的链接 */
export const getHomeUrl: (payload: any) => Promise<HomeUrlType[]> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/link',
    method: 'post',
    data: payload,
    formatData: (data: any) => {
      const { list = [] } = data || {};
      return list;
    }
  }) as Promise<HomeUrlType[]>;
};

/** Home 获取当前用户是否有推荐信息 */
export const getHomeRecommendations: (payload: any) => Promise<HomeUrlType[]> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/homeRecommendations',
    method: 'post',
    data: payload,
    formatData: (data: any) => {
      return data;
    }
  }) as Promise<HomeUrlType[]>;
};

/** Home 当前用户点击推荐信息 */
export const fetchClickHomeRecommendations: (payload: any) => Promise<HomeUrlType[]> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/clickHomeRecommendations',
    method: 'post',
    data: payload,
    formatData: (data: any) => {
      return data;
    }
  }) as Promise<HomeUrlType[]>;
};

/** Home 当前用户点击关闭推荐信息 */
export const fetchClickClosedHomeRecommendations: (payload: any) => Promise<HomeUrlType[]> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/clickClosedHomeRecommendations',
    method: 'post',
    data: payload,
    formatData: (data: any) => {
      const { list = [] } = data || {};
      return list;
    }
  }) as Promise<HomeUrlType[]>;
};

export const getNoteworthyGames: (payload: any) => Promise<NoteworthyType> | NoteworthyType = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/noteworthy_games',
    method: 'post',
    data: payload,
  }).catch(() => {
    return {
      last_date: '',
      list: [],
      error: true,
      code: 404
    };
  }) as Promise<NoteworthyType>;
};

export const getUpcomingGame: (payload: any) => Promise<UpcomingGameType> | UpcomingGameType = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/upcoming_top',
    // url: '/api/v1/homepage/pc/detail/stats/upcoming_top',
    method: 'post',
    data: payload,
    // rawData: true,
    formatData: (data: any) => {
      return {
        list: data || []
      };
    }
  }).catch(() => {
    return {
      data: {
        last_date: '',
        list: [],
        error: true,
        code: 404
      },
      req: null
    };
  }) as Promise<UpcomingGameType>;
};

export const getNewReleaseGame: (payload: any) => Promise<NewReleaseGameType> | NewReleaseGameType = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/new_release_top',
    // url: '/api/v1/homepage/pc/detail/stats/new_release_top',
    method: 'post',
    data: payload,
    formatData: (data: any) => {
      return {
        list: data || []
      };
    }
  }).catch(() => {
    return {
      list: [],
      error: true,
      code: 404,
    };
  }) as Promise<NewReleaseGameType>;
};

export const getBigRiserGame: (payload: any) => Promise<BigRiserGameType> | BigRiserGameType = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/big_risers',
    method: 'post',
    data: payload,
  }).catch(() => {
    return {
      last_date: '',
      list: [],
      error: true,
      code: 404
    };
  }) as Promise<BigRiserGameType>;
};

// 首页热门手游卡片数据
export const getHotMobileGame: () => Promise<any> = () => {
  return http({
    url: '/api/v1/intelligence_pc/home/hot_mobile_game',
    method: 'post',
  }).catch(() => {
    return {
      error: true,
      code: 404
    };
  }) as Promise<any>;
};

// 首页热门PC游戏卡片数据
export const getHotPCGame: () => Promise<any> = () => {
  return http({
    url: '/api/v1/intelligence_pc/home/hot_pc_game',
    method: 'post',
  }).catch(() => {
    return {
      error: true,
      code: 404
    };
  }) as Promise<any>;
};

// 首页热门主机游戏卡片数据
export const getHotConsoleGame: () => Promise<any> = () => {
  return http({
    url: '/api/v1/intelligence_pc/home/hot_console_game',
    method: 'post',
  }).catch(() => {
    return {
      error: true,
      code: 404
    };
  }) as Promise<any>;
};

// 首页表格
export const getGameListFromDashboard: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/dashboard/home/game_list',
    method: 'post',
    data: payload,
    original: true,
  }) as Promise<any>;
};

// 获取七彩石内容
export const getRainbowApi: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/permission/rainbow',
    method: 'post',
    data: payload,
    rawData: true,
  }) as Promise<any>;
};

// 请求ieg global games数据
export const gameListContainTable: (payload: any) => Promise<any> = (payload: any) => {
  return http({
    url: '/api/v1/dashboard_mobile/pcHome/gameListContainTable',
    method: 'post',
    data: payload,
    original: true,
  }) as Promise<any>;
};

/**
 * 获取COS配置信息，包含一下字段信息：
 * region：域
 * bucket：存储桶
 * session_token：临时token
 * temp_secret_id：临时公钥id
 * temp_secret_key：临时公钥key
 * @param payload 获取COS配置信息的入参
 * @returns COS配置信息
 */
export const getCOSConfig = (url?: string): Promise<ICOSConfig> => {
  return http({
    url: url || '/api/v1/homepage/pc/tencent_qcloud/auth',
    method: 'get',
  }) as Promise<ICOSConfig>;
};

/**
 * 提交Feedback
 * @param payload 提交Feedback内容，参数中open_id 新风格系统不用了 所以传空，info_type 不知道干嘛的，固定传1 或者 101
 * @returns
 */
export const postFeedback = (payload: IFeedback): Promise<any> => {
  return http({
    url: '/api/v1/homepage/pc/feedback',
    method: 'post',
    data: {
      open_id: '',
      ...payload,
    },
  }) as Promise<any>;
};

/**
 * saveShowNewBeta
 * @param payload 老版本是否默认进入新风格，payload传参value：show_new_beta（not_show_new_beta）
 * @returns
 */
export const saveShowNewBeta = (payload: ShowNewBeta): Promise<any> => {
  return http({
    url: '/api/v1/dashboard/save_show_new_beta',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

// Feedback图片上传
export const uploadFeedbackImage = (
  payload: FormData,
  options?: {
    onProgress?: (e: ProgressEvent) => void;
  },
): Promise<any> => {
  const { onProgress } = options || {};

  return http({
    url: '/api/v1/homepage/pc/feedback_uploadImg',
    method: 'post',
    data: payload,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: onProgress,
  });
};

// Feedback图片删除
export const deleteFeedbackImage = (payload: { image: string; }): Promise<any> => {
  return http({
    url: '/api/v1/homepage/pc/feedback_delImg',
    method: 'get',
    params: payload,
  });
};
// feedback history
export const trueDataFeedBackHistory = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/detail/trueDataFeedback/history',
    method: 'post',
    data: payload,
  });
};
export const homeHonorTopCharts =  (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/home/honor/topcharts',
    method: 'post',
    data: payload,
  });
};

export const homeHonorTopChartsNew =  (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/home/honor/user_topcharts',
    method: 'post',
    data: payload,
  });
};
